export default {
  authUser(state, data) {
    state.token = data;
  },

  clearAuth(state) {
    state.token = null;
  },

  setStaticCode(state, data) {
    state.staticCode = data;
  },

  setLanguage(state, data) {
    state.selectedLanguage = data;
  },

  // Alert Handles ---------------------------------------

  setPostCheck(state, data) {
    state.postCheck = data;
  },

  setInfo(state, data) {
    state.checkAlert = 4;
    state.infoMessage = data;
  },

  setWarning(state, data) {
    state.checkAlert = 3;
    state.warningMessage = data;
  },

  setError(state, data) {
    state.checkAlert = 2;
    state.dangerMessage = data;
    state.dangerMessage = state.dangerMessage.split("|").join("\n");
  },

  setSuccess(state, data) {
    state.checkAlert = 1;
    state.successMessage = data;
    state.successMessage = state.successMessage.split("|").join("\n");
  },

  expireAlert(state) {
    state.checkAlert = 0;
    state.successMessage = null;
    state.dangerMessage = null;
    state.warningMessage = null;
    state.infoMessage = null;
  },

  setLoading(state, data) {
    state.loadingCheck = data;
  },

  setLoadingBtn(state, data) {
    state.loadingBtn = data;
  },

  toggleMenu(state) {
    state.isMenuActive = !state.isMenuActive;
  },
};
